import websocketMutations from "./mutations.js";
import websocketActions from "./actions.js";
import websocketGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            mySocket:null
        };
    },
    mutations: websocketMutations,
    actions: websocketActions,
    getters: websocketGetters,
};